"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var getSelectInitialValues = function getSelectInitialValues(question) {
  var selectedOptions = (0, _lodash.reduce)(question.response.response_value, function (acc, optionId) {
    return [].concat(_toConsumableArray(acc), [(0, _lodash.find)(question.input_options, {
      id: optionId
    })]);
  }, []);
  if (question.min_selections <= 1 && question.max_selections <= 1) {
    return selectedOptions[0];
  }
  return selectedOptions;
};
var getCheckboxInitialValues = function getCheckboxInitialValues(question) {
  var values = (0, _lodash.reduce)(question.response.response_value, function (acc, value) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, value, true));
  }, {});
  return values;
};
var getResponse = function getResponse(question) {
  switch (question.input_type) {
    case 'select':
      return getSelectInitialValues(question);
    case 'checkbox':
      return getCheckboxInitialValues(question);
    default:
      return question.response.response_value;
  }
};
var getInitialValues = function getInitialValues() {
  var form = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var values = (0, _lodash.reduce)(form.sections, function (acc, section) {
    var questionValues = (0, _lodash.reduce)(section.questions, function (accu, question) {
      if ((0, _lodash.isEmpty)(question.response)) {
        return accu;
      }
      var response = getResponse(question);
      return _objectSpread(_objectSpread({}, accu), _defineProperty({}, question.id, response));
    }, {});
    return _objectSpread(_objectSpread({}, acc), _defineProperty({}, section.id, questionValues));
  }, {});
  return values;
};
var _default = exports["default"] = getInitialValues;